(function ($) {
  Drupal.behaviors.digital_education = {
    attach: function() {
      $('#digital-education').delegate();
      $( 'body' ).on( 'change', '#digital-education', function() {
        const form = $(this).parent().closest('#forskoleforum-custom-digital-education');
        const submit = form.find('#digital-education_submit');
        $(this).is(':checked') ? submit.removeAttr('disabled'): submit.prop('disabled', true);
      });

      var callback = function() {
        if (document.querySelector('.confirmation_form--wrapper') != null) {
          document.querySelector('.digital-edu__overlay').classList.add('active');
          targetNode.querySelector('svg').addEventListener('click', () => {
            document.querySelector('.confirmation_form').replaceChildren();
            document.querySelector('.digital-edu__overlay').classList.remove('active');
          });

          document.querySelector('.digital-edu__overlay').addEventListener('click', () => {
            document.querySelector('.confirmation_form').replaceChildren();
            document.querySelector('.digital-edu__overlay').classList.remove('active');
          })
        }
      }

      const targetNode = document.querySelector('.confirmation_form');

      const config = {
        attributes: true,
        childList: true,
        subtree: true
      };

      const observer = new MutationObserver(callback);

      observer.observe(targetNode, config);
    }
  }
})(jQuery);
